export const flowConsultZH = {
  flowConsult1: '活动',
  flowConsult2: '咨询',
  flowConsult3: '活动相关问题欢迎咨询各区域老师，工作时间：工作日9:30-18:30',
  flowConsult4: '总部地址：',
  flowConsult5: '请填写意见或建议后提交',
  flowConsult6: '请填写联系方式后提交',
  flowConsult7: '提交成功，感谢您的反馈！',
  flowConsult8: '广东省深圳市南山区桃源街道平山社区留仙大道    众冠时代广场',
  flowConsult9: '其他地区'
}

export const flowConsultEN = {
  flowConsult1: 'Event',
  flowConsult2: ' Inquiries',
  flowConsult3: 'If you have any questions about the activity, please consult the teachers in each region, working hours: 9:30-18:30 on weekdays',
  flowConsult4: 'Headquarters address:',
  flowConsult5: 'Please fill in your comments or suggestions and submit',
  flowConsult6: 'Please fill in the contact information and submit',
  flowConsult7: 'Successfully submitted, thanks for your feedback!',
  flowConsult8: 'Zhongguan Times Square, Liuxian Avenue, Pingshan Community, Taoyuan Street, Nanshan District, Shenzhen, Guangdong Province',
  flowConsult9: 'Other areas'
}



// WEBPACK FOOTER //
// ./src/i18n/langs/flow/consult.js